import './MeterBarLayout.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var chartContainer = '_e34p295-2-0-1';
export var container = _7a468({defaultClassName:'_e34p296-2-0-1',variantClassNames:{autoSize:{true:'_e34p297-2-0-1',false:'_e34p298-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var labelContainer = '_e34p294-2-0-1';
export var legendContainer = '_e34p293-2-0-1';
export var maxContainer = '_e34p292-2-0-1';
export var minContainer = '_e34p291-2-0-1';
export var valueContainer = '_e34p290-2-0-1';